import CelcomBuildingImg from './Others/Celcom-Building.png'
import CelcomLogo from './Others/Celcom-Logo.png'
import CelcomDigiLogo from './Others/CD Logo2.jpg'
import footerCelcomDigi from './Others/CD transparent.png'
 
 
export const OtherImages = {
    CelcomBuildingImg, CelcomLogo, CelcomDigiLogo, footerCelcomDigi
}